import { trpc } from "../trpc";
import { RenameTableInput, SearchTablesOutput } from "@zapier/bff";

export type SearchTablesCache = SearchTablesOutput | undefined;

function updateTableInSearchResults(
  cache: SearchTablesCache,
  { tableId, name, description }: RenameTableInput,
): SearchTablesCache {
  if (!cache) {
    return cache;
  }

  return {
    ...cache,
    data: cache.data.map((table) =>
      table.id === tableId ? { ...table, name, description } : table,
    ),
  };
}

interface Input {
  folderId?: string; // optional folderId for invalidating the folder assets query
}

export function useRenameTable(input?: Input) {
  const { folderId } = input || {};
  const utils = trpc.useUtils();

  const mutation = trpc.table.rename.useMutation({
    onMutate(variables) {
      const { tableId } = variables;

      if (!tableId) {
        return;
      }

      utils.table.search.setData({}, (cache: SearchTablesCache) =>
        updateTableInSearchResults(cache, variables),
      );
    },
    onSettled: () => {
      utils.table.search.invalidate();
      if (folderId) {
        utils.asset.getHydratedFolderAssets.invalidate({
          folderId,
        });
      }
    },
  });

  return {
    rename: mutation.mutate,
    isLoading: mutation.isPending,
  };
}
